export const teamData = [
  {
    id: 1,
    slug: "esther-howard",
    name: "Esther Howard",
    position: "Lập trình viên cấp trung",
    homeImg: "/assets/img/team/01.webp",
    image: "/assets/img/team/05.jpg",
    detailsImage: "/assets/img/team/details-1.jpg",
    about: `Là thành viên chủ chốt của agency sáng tạo, Esther Howard có nền tảng trong thiết kế và marketing. Cô chuyên tạo ra các giải pháp sáng tạo phù hợp với mục tiêu và tầm nhìn của khách hàng.`,
    location: "Tây Ban Nha, Barcelona",
    email: "esther@example.com",
    birthYear: 1996, // 2025 - 29
    qualification: "Cử nhân",
    gender: "Nữ",
    portfolio: [
      { name: "Behance", url: "#" },
      { name: "Dribble", url: "#" },
      { name: "Medium", url: "#" },
    ],
    socials: { facebook: "#", twitter: "#", instagram: "#", linkedin: "#" },
  },
  {
    id: 2,
    slug: "shikhon-islam",
    name: "Shikhon Islam",
    position: "Lập trình viên Frontend",
    image: "/assets/img/team/06.jpg",
    homeImg: "/assets/img/team/01.jpg",
    detailsImage: "/assets/img/team/details-1.jpg",
    about: `Với chuyên môn vững chắc về công nghệ frontend, Shikhon tạo ra UI/UX hiện đại và giúp đẩy nhanh tiến trình phát triển sản phẩm.`,
    location: "Bangladesh, Dhaka",
    email: "shikhon@example.com",
    birthYear: 1994, // 2025 - 31
    qualification: "Thạc sĩ",
    gender: "Nam",
    portfolio: [
      { name: "Behance", url: "#" },
      { name: "Dribble", url: "#" },
    ],
    socials: { facebook: "#", twitter: "#", instagram: "#", linkedin: "#" },
  },
  {
    id: 3,
    slug: "leslie-alexander",
    name: "Leslie Alexander",
    position: "Điều phối viên Marketing",
    image: "/assets/img/team/07.jpg",
    homeImg: "/assets/img/team/01.jpg",
    detailsImage: "/assets/img/team/details-1.jpg",
    about: `Leslie chuyên xây dựng và triển khai các chiến lược marketing giúp doanh nghiệp tăng trưởng và mở rộng.`,
    location: "Tây Ban Nha, Barcelona",
    email: "leslie@example.com",
    birthYear: 1983, // 2025 - 42
    qualification: "Thạc sĩ",
    gender: "Nam",
    portfolio: [
      { name: "Behance", url: "#" },
      { name: "Dribble", url: "#" },
      { name: "Medium", url: "#" },
    ],
    socials: { facebook: "#", twitter: "#", instagram: "#", linkedin: "#" },
  },
  {
    id: 4,
    slug: "cody-fisher",
    name: "Cody Fisher",
    position: "Nhà thiết kế UI/UX",
    image: "/assets/img/team/07.jpg",
    homeImg: "/assets/img/team/01.jpg",
    detailsImage: "/assets/img/team/details-1.jpg",
    about: `Cody đam mê thiết kế lấy người dùng làm trung tâm và luôn đảm bảo mỗi sản phẩm mang lại trải nghiệm mượt mà.`,
    location: "Mỹ, New York",
    email: "cody@example.com",
    birthYear: 1998, // 2025 - 27
    qualification: "Cử nhân",
    gender: "Nam",
    portfolio: [
      { name: "Behance", url: "#" },
      { name: "Dribble", url: "#" },
    ],
    socials: { facebook: "#", twitter: "#", instagram: "#", linkedin: "#" },
  },
  {
    id: 5,
    slug: "jenny-wilson",
    name: "Jenny Wilson",
    position: "Quản lý dự án",
    image: "/assets/img/team/07.jpg",
    homeImg: "/assets/img/team/01.jpg",
    detailsImage: "/assets/img/team/details-1.jpg",
    about: `Jenny đảm bảo dự án được hoàn thành đúng tiến độ, đúng ngân sách và duy trì giao tiếp hiệu quả với khách hàng.`,
    location: "Anh, London",
    email: "jenny@example.com",
    birthYear: 1990, // 2025 - 35
    qualification: "Thạc sĩ",
    gender: "Nữ",
    portfolio: [
      { name: "Medium", url: "#" },
      { name: "LinkedIn", url: "#" },
    ],
    socials: { facebook: "#", twitter: "#", instagram: "#", linkedin: "#" },
  },
  {
    id: 6,
    slug: "robert-fox",
    name: "Robert Fox",
    position: "Kỹ sư Backend",
    image: "/assets/img/team/07.jpg",
    homeImg: "/assets/img/team/01.jpg",
    detailsImage: "/assets/img/team/details-1.jpg",
    about: `Robert là chuyên gia về công nghệ phía máy chủ và kiến trúc hệ thống, tập trung vào hiệu suất và khả năng mở rộng.`,
    location: "Đức, Berlin",
    email: "robert@example.com",
    birthYear: 1987, // 2025 - 38
    qualification: "Tiến sĩ Khoa học Máy tính",
    gender: "Nam",
    portfolio: [
      { name: "GitHub", url: "#" },
      { name: "Medium", url: "#" },
    ],
    socials: { facebook: "#", twitter: "#", instagram: "#", linkedin: "#" },
  },
  {
    id: 7,
    slug: "nguyen-van-a",
    name: "Nguyễn Văn A",
    position: "Thiết kế Đồ họa",
    image: "/assets/img/team/07.jpg",
    homeImg: "/assets/img/team/01.jpg",
    detailsImage: "/assets/img/team/details-1.jpg",
    about: `Nguyễn Văn A có kinh nghiệm trong thiết kế đồ họa, chuyên tạo ra các sản phẩm sáng tạo, bắt mắt và phù hợp thương hiệu.`,
    location: "Việt Nam, Hà Nội",
    email: "nguyenvana@example.com",
    birthYear: 1995, // 2025 - 30
    qualification: "Cử nhân Mỹ thuật",
    gender: "Nam",
    portfolio: [
      { name: "Behance", url: "#" },
      { name: "Dribble", url: "#" },
    ],
    socials: { facebook: "#", twitter: "#", instagram: "#", linkedin: "#" },
  },
  {
    id: 8,
    slug: "tran-thi-b",
    name: "Trần Thị B",
    position: "Digital Marketing",
    image: "/assets/img/team/07.jpg",
    homeImg: "/assets/img/team/01.jpg",
    detailsImage: "/assets/img/team/details-1.jpg",
    about: `Trần Thị B chuyên quản lý chiến dịch Digital Marketing, tối ưu SEO, quảng cáo và mạng xã hội, giúp thương hiệu phát triển trực tuyến.`,
    location: "Việt Nam, TP. Hồ Chí Minh",
    email: "tranthib@example.com",
    birthYear: 1997, // 2025 - 28
    qualification: "Cử nhân Marketing",
    gender: "Nữ",
    portfolio: [
      { name: "LinkedIn", url: "#" },
      { name: "Medium", url: "#" },
    ],
    socials: { facebook: "#", twitter: "#", instagram: "#", linkedin: "#" },
  },
];
